import { render } from "./CompanyContactDetail.vue?vue&type=template&id=57d0c5d9&scoped=true&ts=true"
import script from "./CompanyContactDetail.vue?vue&type=script&lang=ts"
export * from "./CompanyContactDetail.vue?vue&type=script&lang=ts"

import "./CompanyContactDetail.vue?vue&type=style&index=0&id=57d0c5d9&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d0c5d9"]])

export default __exports__